var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMostActiveDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5V6.5H7L8.70013 2.24967C8.88124 1.79689 9.31977 1.5 9.80742 1.5C10.4661 1.5 11 2.03394 11 2.69258V6.5H13.8827C14.4787 6.5 14.9424 7.01807 14.8766 7.61043L14.1977 13.7209C14.0851 14.7337 13.229 15.5 12.2099 15.5H1Z",
    stroke: "#006CFA",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5V15.5",
    stroke: "#006CFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostActiveDay);
export default __webpack_public_path__ + "static/media/most-active-day.bc3e4c0e88bf2d8ae574eb2fc54c42d8.svg";
export { ForwardRef as ReactComponent };